export default{
  props: ['value'],
  data() {
    return {
      visible: false
    }
  },
  watch: {
    visible(val){
      this.$emit('input', val)
    },
    value(val){
      this.visible = val
    }
  }
}